/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENTS_TAB = "ALL_COMMENTS" | "FEATURED_COMMENTS" | "NONE" | "UNANSWERED_COMMENTS" | "%future added value";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type StreamContainerLocal = {
    readonly siteID: string | null;
    readonly commentsTab: COMMENTS_TAB;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly " $refType": "StreamContainerLocal";
};
export type StreamContainerLocal$data = StreamContainerLocal;
export type StreamContainerLocal$key = {
    readonly " $data"?: StreamContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"StreamContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "siteID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsTab",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'fde122b2ebfff4c806f3ade2308c8d17';
export default node;
